"use client";

import { useState } from "react";
import type { Variety } from "@/lib/catalog/types";
import { GradePicker } from "./GradePicker";
import { DetailPricingPanel } from "./DetailPricingPanel";

// Wraps DetailPricingPanel for group-aware detail pages. Maintains the
// active variant when the user clicks a grade chip, then re-renders the
// pricing panel with the new variant.
export function GroupedDetailPanel({
  variants,
  initialSlug,
  soldOutKeys,
}: {
  variants: Variety[];
  initialSlug: string;
  // #452: sold-out keys for this card's variants (variety/color/length scopes).
  soldOutKeys?: string[];
}) {
  const initialIdx = Math.max(
    0,
    variants.findIndex((v) => v.slug === initialSlug),
  );
  const [activeIdx, setActiveIdx] = useState(initialIdx === -1 ? 0 : initialIdx);
  const active = variants[activeIdx];
  return (
    <div className="space-y-5">
      <GradePicker
        variants={variants}
        activeSlug={active.slug}
        onChange={(next) => {
          const i = variants.findIndex((v) => v.slug === next.slug);
          if (i >= 0) setActiveIdx(i);
        }}
      />
      <DetailPricingPanel variety={active} soldOutKeys={soldOutKeys} />
    </div>
  );
}
